













import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";

@Component({
    name: "AInputBarCode"
})
export default class extends Vue {
    @Prop({ default: "Quét hoặc nhập mã và enter", type: String }) readonly placeholder!: string;
    @Model("change") readonly barCode!: string|undefined;
    @Emit("change")
    onChangeBarCode(val: any) {
        return val;
    }

    @Emit("submit")
    onSubmitBarCode(evt: any) {
        return evt;
    }

    get barCodeTrue() {
        return this.barCode;
    }

    set barCodeTrue(val: any) {
        this.onChangeBarCode(val);
    }

    focus() {
        (this.$refs.barCodeTrue as any).focus();
    }
}
